import { render, staticRenderFns } from "./PanelInitial.vue?vue&type=template&id=604d74a0&scoped=true&"
import script from "./PanelInitial.vue?vue&type=script&lang=js&"
export * from "./PanelInitial.vue?vue&type=script&lang=js&"
import style0 from "./PanelInitial.vue?vue&type=style&index=0&id=604d74a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d74a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
